module.exports = __webpack_public_path__ + "static/img/zdkj.9809a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zdkj.png
// module id = d0BV
// module chunks = 0